module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6XoOLx/tc-custom/9781423651567.jpg?1699128906922",
      "alt": "This image is the cover for the book Kevin Belton's New Orleans Celebrations"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Kevin Belton's New Orleans Celebrations\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The Crescent City chef takes readers on a tour of the city’s many food festivals with recipes guaranteed to get the party started.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" New Orleans is known as the Festival Capital of the World, hosting dozens of annual festivals that showcase the unique food and multicultural heritage of the city. Now the star of New Orleans Cooking with Kevin Belton invites home chefs everywhere to experience the celebratory culture of the Big Easy with these essential and irresistible Louisiana dishes."), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Kevin Belton’s New Orleans Celebrations")]), _vm._v(" is a smorgasbord of delicious creations from vibrant festivals like the French Market Creole Tomato Festival, Bastille Day Fête, the Crescent City Blues and BBQ Festival, and more. Recipes include Ham Croquettes with Pear Pepper Jelly, Bacon and Barbecue Quiche, Crawfish Enchiladas and Creole Tomato, and Crawfish Macaroni and Cheese.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kevin Belton, Rhonda K. Findley\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0